import { $translate } from '@/utils/i18n';
export const tableConfig = {
    configuration: true,
    searchList: {
        searchTxt: [],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        selectBtn: true,
        clickState: true,
        leftOperation: false,
        height: 400,
        columns: [
            {
                label: $translate('lang.E2202203100002', { defaultText: '事业部' }),
                align: 'center',
                prop: 'entityName',
                filter: true,
                require: true,
                sort: true,
                width: 120
            },
            {
                label: $translate('lang.E2202203100001', { defaultText: '原集团编码' }),
                align: 'center',
                prop: 'salesCenCode',
                filter: true,
                require: true,
                sort: true,
                width: 120
            },
            {
                label: $translate('lang.E2202203100003', { defaultText: '原集团单位' }),
                align: 'center',
                prop: 'salesCenName',
                filter: true,
                require: true,
                sort: true,
                width: 120
            },
            {
                label: $translate('lang.E3202101270009', { defaultText: '扫码单位编码' }),
                align: 'center',
                prop: 'orgCode',
                filter: true,
                require: true,
                sort: true,
                width: 120
            },
            {
                label: $translate('lang.E3202101270010', { defaultText: '扫码单位名称' }),
                align: 'center',
                prop: 'orgName',
                filter: true,
                require: true,
                sort: true,
                width: 120
            },
            {
                label: $translate('lang.E3202101270013', { defaultText: '扫码场景' }),
                align: 'center',
                prop: 'opPerson',
                filter: true,
                require: true,
                sort: true,
                width: 120
            },
            {
                label: $translate('lang.E3202101270011', { defaultText: '单据日期' }),
                align: 'center',
                prop: 'billDate',
                filter: true,
                require: true,
                sort: true,
                width: 120
            },
            {
                label: $translate('lang.E3202101270014', { defaultText: '开单数' }),
                align: 'center',
                prop: 'billQty',
                filter: true,
                require: true,
                sort: true,
                width: 90
            },
            {
                label: $translate('lang.E3202101270015', { defaultText: '扫码数' }),
                align: 'center',
                prop: 'scanQty',
                filter: true,
                require: true,
                sort: true,
                width: 90
            },
            {
                label: $translate('lang.E3202101270016', { defaultText: '扫码率' }),
                align: 'center',
                type: 'underLine',
                prop: 'scanRate',
                filter: true,
                require: true,
                sort: true,
                width: 90
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    },
    showPage: true
};
